import React, { useEffect, useState } from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import { homeService, IMonthLineType } from './homeService';

export const DiscernMonthLine = () => {

	const [dataSource, setDataSource] = useState<IMonthLineType[]>([]);

	useEffect(() => {
		homeService.monthStatistics().then(res => {
			res?.retData && setDataSource(res?.retData);
		})
	}, [])

	const option = {
		grid: {
			left: 50,
			right: 20,
			top: 30,
		},
		//图例
		legend: {
			type: "plain",
			right: 0,

			textStyle: {
				color: "#fff"
			},
			data: [{
				name: '过滤数量',
				textStyle: {
					color: '#fff'
				},
				icon: 'roundRect'
			}, {
				name: '识别数量',
				textStyle: {
					color: '#fff'
				},
				icon: 'roundRect'
			}]
		},
		//提示框
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			}
		},
		//直角坐标系 grid 中的 x 轴
		xAxis: {
			type: 'category',
			boundaryGap: false,
			axisTick: {
				show: false
			},
			axisLine: {
				lineStyle: {
					color: "#0E66C3",
				}
			},
			// data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
			data: dataSource.map(item => item.month)
		},
		//直角坐标系 grid 中的 y 轴
		yAxis: {
			type: 'value',
			axisLine: {
				lineStyle: {
					color: "#CCCCCC",
				}
			},
			//设置网格线颜色
			splitLine: {
				lineStyle: {
					color: ['#3C4B80'],
				}
			},
		},

		dataZoom: [{
			type: 'inside',
			throttle: 50
		}],
		series: [
			{
				name: '识别数量',
				type: 'line',
				smooth: true,
				stack: 'a',
				itemStyle: {
					color: '#44F0FF',
					borderWidth: 10,
				},
				areaStyle: {
					color: {
						type: 'linear',
						x: 1,
						y: 1,
						r: 0.6,
						colorStops: [{
							offset: 0, color: '#0F2251' // 0% 处的颜色
						}, {
							offset: 1, color: '#215D89' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
				data: dataSource.map(item => item.distinguishNum)
			},
			{
				name: '过滤数量',
				type: 'line',
				smooth: true,  //则表示是否开启平滑处理
				stack: 'a',
				itemStyle: {
					color: '#E6307B',
					borderWidth: 10,
				},
				areaStyle: {
					color: {
						type: 'linear',
						x: 1,
						y: 1,
						r: 0.6,
						colorStops: [{
							offset: 0, color: '#0C1740' // 0% 处的颜色
						}, {
							offset: 1, color: '#54366D' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
				data: dataSource.map(item => item.filterNum)
			},
		]
	};

	return (
		<div className="home-content-right-discernWeekMonth">
			<div className="home-but-wrapper">
				<span>月过滤/识别数量分析</span>
			</div>
			<ReactEchartsCore
				echarts={echarts}
				theme="line"
				option={option as any}
			// style={{height:"100%"}}
			/>
		</div>
	);
};

